export default "__VITE_ASSET__B4_kESPG__"